/**
 * Where the applied liability type of a ProvisionContractAgent row came from (04-frontend.md
 * §2.6, E3/A3-05).
 *
 * THREE constants, in ascending precedence: {@link ASSIGNMENT} is the normal path via the liability
 * assignment (K-07); {@link MATRIX_OVERWRITE} is an explicit liability type overwrite on the matrix
 * ASSIGNMENT (K-10) and beats it; {@link MATRIX_ROW_OVERWRITE} is an overwrite on the matrix ROW
 * itself (K-09) and beats both (E-10). There is no fourth value for "no liability" — that case is a
 * real data row, the technical liability type `no_liability` (A3-02), not a nullable source.
 *
 * {@link MATRIX_ROW_OVERWRITE} was missing from this mirror while the backend has carried it since
 * E-10 was implemented. It is the value the reference tenant produces most, so its absence meant a
 * surface branching on this enum silently fell through on the majority of its rows.
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionLiabilitySource}.
 * The backend persists the ordinal (`@Enumerated(EnumType.ORDINAL)`), so the declaration order
 * below MUST match the backend exactly and new constants MUST only be appended at the end — never
 * inserted between existing ones, which would silently re-map every stored value
 * (02-datenmodell.md §0.5/§2).
 */
export enum ProvisionLiabilitySource {

    /** Ordinal 0 — "Zuordnung". The liability type comes from the liability assignment (K-07). */
    ASSIGNMENT,

    /** Ordinal 1 — "Matrix-Überschreibung". The overwrite on the matrix assignment (K-10) won. */
    MATRIX_OVERWRITE,

    /** Ordinal 2 — "Matrixzeilen-Überschreibung". The overwrite on the matrix row (K-09) won. */
    MATRIX_ROW_OVERWRITE
}
